export default {"src":"/_next/static/media/icon-compare.0c30ab45.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};